import React, { useEffect, useMemo, useState, useRef, Fragment, useLayoutEffect, useCallback } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import mixpanel from 'mixpanel-browser';
import { hotjar } from 'react-hotjar';
import styles from '../Panel.module.css';
import { makeStyles, useTheme, Theme, createStyles } from '@material-ui/core/styles';
import { Paper, Tabs, Box, Tab, CircularProgress, Popper, TextareaAutosize, Input, InputBase, Divider, FormHelperText, Typography, Stepper, Step, StepLabel, StepContent, StepButton, Button, InputLabel, Menu, MenuItem, FormControl, Select, TextField, ListItemIcon, Avatar, ListItemText, Grid, AccordionSummary, InputAdornment, Modal, Chip, ButtonGroup } from '@material-ui/core'
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';
import Authorizer from '../Authorizer'
import Inspector from 'react-json-inspector';
import '../helpers/json-inspector.css';
import '../helpers/workload-tags.css'; //add styling for the tags in input fields
import '../helpers/workload-mode-single-line-style.css';// add .cm-custom-keyword class here
import 'codemirror/addon/search/searchcursor';
import AppsRoundedIcon from '@material-ui/icons/AppsRounded';
import IconButton from '@material-ui/core/IconButton';
import MoreHorizRoundedIcon from '@material-ui/icons/MoreHorizRounded';
import BuildRoundedIcon from '@material-ui/icons/BuildRounded';
import FavoriteRoundedIcon from '@material-ui/icons/FavoriteRounded';
import SettingsEthernetRoundedIcon from '@material-ui/icons/SettingsEthernetRounded';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';
import CreateRoundedIcon from '@material-ui/icons/CreateRounded';
import RefreshRoundedIcon from '@material-ui/icons/RefreshRounded';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@material-ui/icons/KeyboardArrowUpRounded';
import { WarningRounded } from '@material-ui/icons';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import { Alert, AlertTitle, Autocomplete, createFilterOptions } from '@material-ui/lab';
import { alertName } from '../../redux/ducks/notification';
// import { ptree } from '../../redux/ducks/pTree';
// import { nodeid } from '../../redux/ducks/nodeID';
import Form from "@rjsf/material-ui";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { FieldsRender, DynamicFieldsRender } from '../helpers/panel-functions'
import { useStoreState } from 'react-flow-renderer';
import DataInspector from './DataInspector';
import WorkflowErrorBoundary from '../WorkflowErrorBoundary';
import config from '../../config/environment';
import { trackAppSelected, trackEventSelected, trackCredentialConnected, trackTestDataCreated, trackFieldMapped } from '../../utils/posthog';


import {
    nodeAdded, edgeAdded, elementUpdated, nameUpdated, elementDeleted, fetchWorkflow, nodeEdgeAdded, saveWorkflow, elementSelected, testNode, selectLoadingPerform,
    selectWorkflowElements, selectElementById, selectWorkflowName, selectWorkflowId, selectParentTree, selectWorkflowTemplate, selectWorkflowTemplateNodes, selectWorkflowActive, selectCurrentElement
} from '../../features/workflow/workflowSlice'

import { selectAllActions } from '../../features/allApps/allAppsSlice'
import { isArray } from 'util';

//import { selectAllPopular } from '../../features/allApps/allAppsSlice'

Function.deserialise = function (key, data) {
    return (data instanceof Array && data[0] == 'window.Function') ?
        new (Function.bind.apply(Function, [Function].concat(data[1], [data[2]]))) :
        data
        ;
};

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function Carat(props) {
    const isActive = props.active;
    if (isActive) {
      return <KeyboardArrowUpRoundedIcon />;
    }
    return <KeyboardArrowDownRoundedIcon />;
  }

function timeSince(date) {

    var seconds = Math.floor((new Date() - date) / 1000);
  
    var interval = seconds / 31536000;
  
    if (interval > 1) {
      return Math.floor(interval) + " years";
    }
    interval = seconds / 2592000;
    if (interval > 1) {
      return Math.floor(interval) + " months";
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes";
    }
    return Math.floor(seconds) + " seconds";
  }

function getModalStyle() {
    const top = 25
    //  const left = 50 + rand();

    return {
        top: `${top}%`,
        margin: 'auto'
        // left: `${left}%`,
        // transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    removeappbutton: {
        '& > *': {
            margin: theme.spacing(1),

        },
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    actionsContainer: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        zIndex: 99,
        marginTop: '20px'
    },
    resetContainer: {
        padding: theme.spacing(1),
    },
    selectInput: {
        '*': {
            display: 'flex'
        }
    },
    chiproot: {
        display: 'flex',
        left: 5,
        marginLeft: '20px',
        width: '99%',
        float: 'left',
        '& > *': {
            margin: '-10px',

        },
        "& > *:hover": {
            border: '2px solid',
            borderColor: "#0069ea"
        }
    },
    accordionroot: {
        width: '90px',
    },
    accordionheading: {
        fontWeight: 700,
    },
    dropdownroot: {
        position: 'relative',
    },
    small: {
        width: '22px',
        height: '22px',
        marginRight: '4px'
    },
    dropdown: {
        position: 'absolute',
        width: '500px',
        right: 0,
        left: 10,
        zIndex: 5,

        // borderTop: '1px solid',
        // borderLeft: '1px solid',
        boxShadow: "1px 0px 0px lightgrey",
        borderColor: 'lightgrey',
        borderRadius: '5px',
        padding: '4px',
        backgroundColor: theme.palette.background.paper,
        opacity: '1',
        overflowX: "hidden",
        height: 'auto',
        maxHeight: '500px',
        overflowY: "auto"

    },
    codemirror: {
        marginTop: '7px',
        border: '1px solid',
        borderColor: 'lightgrey',
        borderRadius: '4px',
        paddingTop: '4px',
        paddingRight: '4px',
        paddingBottom: '4px',
        justifyContent: 'center',
        width: 'inherit',
        height: '48px',
        display: 'relative',
        //position: 'absolute'
        '&:hover': {
            borderColor: 'black',
            border: '1px solid'
        },
        '&:focus-within': {
            borderColor: '#0069ea',
            border: '2px solid'
        }
    },
    resetContainer: {
        padding: theme.spacing(1),
    },
    modal: {
        position: 'absolute',
        width: 800,
        backgroundColor: theme.palette.background.paper,
        border: '0px solid #000',
        borderRadius: '4px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
    headerbox: {
        width: '100%',
        maxWidth: '100%',
        marginLeft: '20px',
        marginBottom: '20px',
        display: 'block',
        minWidth: 0,
        boxSizing: 'border-box'
    },
    popper: {
        border: '1px solid lightgray',
        borderRadius: '4px',
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.paper,
        zIndex: 999,
        height: '400px',
        boxShadow: '0 5px 5px 5px lightgray',
        width: '500px'
    },
    tabs: {
        flexGrow: 1,
        elevation: 0
    }
}));

const muiTheme = createMuiTheme({
    palette: {
        primary: { main: '#0069ea' },
        secondary: { main: '#ff5555' }
    },
    props: {
        MuiTextField: {
            variant: 'outlined'
        }
    }
});

const globalHttpRequest = {
    "workload_http": {
        "title": "Custom Request",
        "fields": [
            {
                "name": "HTTP Request",
                "in": "path",
                "required": true,
                "schema": {
                    "type": "object",
                    "properties": {
                        "requestType": {
                            "title": "Request Type",
                            "type": "string",
                            "enum": [
                                "GET",
                                "POST",
                                "PUT",
                                "PATCH",
                                "DELETE"
                            ]
                        },
                        "url": {
                            "title": 'URL',
                            "type": "string"
                        },
                        "params": {
                            "title": "URL Parameters",
                            "type": "array",
                            "items": {
                                "type": "object",
                                "properties": {
                                    "key": {
                                        "title": "Key",
                                        "type": "string"
                                    },
                                    "value": {
                                        "title": "Value",
                                        "type": "string"
                                    }
                                }
                            }
                        },
                        "stringBody": {
                            "type": "string",
                            "title": "JSON Body",
                            "description": "Note: this field is ignored for GET requests"
                        }
                    }
                }
            }
        ],
        "url": "",
        "method": ""
    }
}

function ActionPanel({ selectedNode, deleteNode, sendNode, workflowID, parentTree, user, tenant, onPaneClick, sendLoggedOutToAuthorizer, breakpoint, inlineLayout = false }) {
    const theme = useTheme();
    const node = useSelector(selectElementById(selectedNode.id))
    const [name, setName] = useState(node.data.name);
    const [app, setApp] = useState(node.data.app || node.data.type);
    const [label, setLabel] = useState(node.data.label);
    const [icon, setIcon] = useState(node.data.icon);
    const [custombutton, setCustomButton] = useState(node.data.custombutton)
    const allApps = useSelector(selectAllActions)
    const [actions, setActions] = useState([]);
    const workflow = useSelector(selectWorkflowTemplateNodes)
    const loadingperform = useSelector(selectLoadingPerform)
    const [loadedActions, setLoadedActions] = useState(false);
    const [action, setAction] = useState(node.data.action);
    const [actionlabel, setActionLabel] = useState(node.data.actionlabel ?? "")
    const [credentialId, setCredentialId] = useState(node.data.credential)
    const [authname, setAuthname] = useState(node.data.authname)
    const [loading, setLoading] = useState(true);
    const [nosave, setNoSave] = useState(0);
    const [url, setURL] = useState(node.data.url)
    const [actionTestTime, setActionTestTime] = useState(node.data.actionTestTime)
    const [showTestData, setShowTestData] = useState(false)
    const [sentData, setSentData] = useState()
    const [activeStep, setStep] = useState(0)
    // Initialize fields from node data, but allow undefined/null so fields can be loaded from actions
    const [fields, setFields] = useState(node.data.fields || undefined)
    const [hasauth, setHasAuth] = useState(node.data.hasauth)
    const [testData, setTestData] = useState(node.data.testData)
   
    const bottomRef = useRef(null);
    const isSyncingFromReduxRef = useRef(false); // Flag to prevent infinite loop when syncing from Redux
    const prevFieldsRef = useRef(fields); // Track previous fields to detect field-only changes
    const prevNodeStateRef = useRef({ name, app, label, icon, hasauth, action, credentialId, authname }); // Track other state to detect non-field changes
    const nodeDataRef = useRef(node?.data); // Latest node.data for stable callbacks (avoids handleSetFields changing when node reference updates after save)
    nodeDataRef.current = node?.data;
    const hasDynamicForm = action && Object.keys(actions).length > 0 && actions[action]?.dynamicForm
    const finalStep = (hasauth ? hasDynamicForm ? 6 : 5 : 4)
    const testStep = hasauth ? hasDynamicForm ? 5 : 4 : 3
    const dynamicStep = hasauth ? 4 : 3
    const storeState = useStoreState((state) => state);
    const [appChanged, setAppChanged] = useState(false)
    const [eventChanged, setEventChanged] = useState(false)
    const [recentAppsUpdated, setRecentAppsUpdated] = useState(0)
    const [selectedAppObject, setSelectedAppObject] = useState(null)
    
    // Helper function to save recent apps to localStorage
    const saveRecentApp = (appObj, type = 'action') => {
        const storageKey = `recentApps_${type}`;
        let recentApps = [];
        try {
            const stored = localStorage.getItem(storageKey);
            if (stored) {
                recentApps = JSON.parse(stored);
            }
        } catch (e) {
            console.error('Error reading recent apps:', e);
        }
        
        // Remove if already exists
        recentApps = recentApps.filter(item => item.name !== appObj.name);
        
        // Add to beginning
        recentApps.unshift({
            name: appObj.name,
            app: appObj.app,
            icon: appObj.icon,
            auth: appObj.auth,
            custombutton: appObj.custombutton,
            formDataEndpoint: appObj.formDataEndpoint,
            category: appObj.category
        });
        
        // Keep only last 8
        recentApps = recentApps.slice(0, 8);
        
        try {
            localStorage.setItem(storageKey, JSON.stringify(recentApps));
        } catch (e) {
            console.error('Error saving recent apps:', e);
        }
    };
    
    // Helper function to get recent apps from localStorage
    const getRecentApps = (type = 'action') => {
        const storageKey = `recentApps_${type}`;
        try {
            const stored = localStorage.getItem(storageKey);
            if (stored) {
                return JSON.parse(stored);
            }
        } catch (e) {
            console.error('Error reading recent apps:', e);
        }
        return [];
    };
    
    // Get recent apps with memoization
    const recentApps = useMemo(() => getRecentApps('action'), [recentAppsUpdated])


    // Whenever action or actionlabel changes, clear testData
useEffect(() => {
    if (eventChanged === true) {
    setTestData(null);
    setEventChanged(false)
    }
  }, [eventChanged]);
  
  // Whenever app (type) changes, clear out action, actionlabel, authname, credential, and testData
  useEffect(() => {
    if (appChanged === true) {
    setAction('');
    setActionLabel('');
    setAuthname('');
    setCredentialId('');
    setTestData(null);
    setAppChanged(false)
    }
  }, [appChanged]);
  
  
    // Canvas centering is handled by flowApp fitView so all panel views stay consistent (Agent / ReadOnly / Advanced)




    const dispatch = useDispatch();





    const colors = [
        'primary',
        'secondary'
    ];

    const [color, setColor] = useState(0);

    useEffect(() => {
        if (loading === false) {
            const interval = setInterval(() => {
                setColor((v) => (v === 2 ? 0 : v + 1));
            }, 1500);
            
            return () => clearInterval(interval);
        } else {
            setColor(0);
        }
    }, [loading]);



    // Helper function to handle chip click - select the app
    const handleChipClick = (appObj) => {
        // Save to recent apps
        saveRecentApp(appObj, 'action');
        
        // Find the matching app object from allApps or tabApps to set as Autocomplete value
        const appList = tabApps ?? allApps ?? [];
        const matchingApp = appList.find(app => 
            app.name === appObj.name || 
            app.app === appObj.app ||
            (app.name && appObj.name && app.name.toLowerCase() === appObj.name.toLowerCase())
        ) || appList.find(app => app.app === appObj.app);
        
        // Clear all related state when app changes
        setAppChanged(true);
        setAction('');
        setActionLabel('');
        setAuthname('');
        setCredentialId('');
        setTestData(null);
        
        // Update app-related state
        setApp(appObj.app);
        setLabel(appObj.name);
        setIcon(appObj.icon);
        setCustomButton(appObj.custombutton);
        setURL(appObj.formDataEndpoint);
        // Set hasauth based on app's auth property
        setHasAuth(appObj.auth === true);
        
        // Track app selected
        trackAppSelected(appObj.name, appObj.app, 'action');
        
        // Update the selected app object for Autocomplete
        if (matchingApp) {
            setSelectedAppObject(matchingApp);
        } else {
            // If no match found, create a synthetic app object from appObj
            setSelectedAppObject(appObj);
        }
        
        // Update node name - set to default first, then update
        setName('Add action');
        setNodeNameAuto(appObj.name, undefined);
        
        // Save the changes with description
        saveNode('changed app');
        
        // Force re-render recent apps
        setRecentAppsUpdated(Date.now());
    };

    const saveNode = (description) => {
        const newNode = node
        dispatch(elementUpdated(selectedNode.id,
            {
                name: name,
                type: app,
                actionlabel: actionlabel,
                label: label,
                icon: icon,
                hasauth: hasauth,
                custombutton: custombutton,
                action: action,
                credential: credentialId,
                authname: authname,
                fields: fields,
                testData: testData,
                url: url,
                actionTestTime: actionTestTime
            },
            null,
            description
        ));
    }
    
    // Save only fields (for field mapping changes) - preserves rest of node state
    const saveFieldsOnly = (newFields) => {
        dispatch(elementUpdated(selectedNode.id,
            {
                ...node.data, // Preserve all existing node data
                // CRITICAL: Always preserve type/app from current local state, not stale node.data
                // This prevents type from being unset when fields are saved
                type: app || node.data.type, // Use current app state, fallback to node.data.type
                fields: newFields // Only update fields
            },
            null,
            'changed field mapping'
        ));
    }

    // Stable callback for FieldsRender so it never gets a new reference when node updates after save (prevents Menu/Select update loop).
    // Use nodeDataRef.current inside so we don't depend on node?.data in deps.
    const handleSetFields = useCallback((updatedOrUpdater) => {
        setFields((prev) => {
            const next = typeof updatedOrUpdater === 'function' ? updatedOrUpdater(prev) : updatedOrUpdater;
            if (!Array.isArray(next)) return next;
            // Skip update and dispatch when value unchanged (stops RJSF/Form onChange loop)
            if (JSON.stringify(prev) === JSON.stringify(next)) return prev;
            const nodeData = nodeDataRef.current;
            dispatch(elementUpdated(selectedNode.id,
                { ...nodeData, type: app || nodeData?.type, fields: next },
                null,
                'changed field mapping'
            ));
            return next;
        });
    }, [dispatch, selectedNode?.id, app]);

    // Function to check if all required fields are filled
    const areRequiredFieldsFilled = () => {
        if (!fields || fields.length === 0) return true;
        
        return fields.every(field => {
            // Skip hidden fields
            if (field.hidden) return true;
            
            // Check if field is required
            if (field.required) {
                // Check if field has a value
                if (field.value === undefined || field.value === null || field.value === '') {
                    return false;
                }
            }
            return true;
        });
    }

    const testNodeClick = () => {
       // setTestLoading(true);
      //  setTestData("");
       // saveNode(); 
        setStep(activeStep + 1);
        setActionTestTime(Date.now());
        dispatch(testNode(selectedNode.id))
    }


    useEffect(() => {
        let isMounted = true;
        // When opening in manual mode, node may have app (type) but no url (e.g. AI-created node). Resolve url and hasauth from allApps.
        const foundApp = app && Array.isArray(allApps) && allApps.length > 0 ? allApps.find((x) => x.app === app) : null;
        const resolvedUrl = url || (foundApp?.formDataEndpoint || null);

        // Always sync hasauth from app schema when we have a matching app, so the Account step shows when the app requires auth
        // (node.data.hasauth may be missing when opening manual mode with an app that already has url)
        if (app && foundApp) {
            const appAuth = foundApp.auth === true;
            setHasAuth(appAuth);
            // Persist so Redux sync effect doesn't overwrite and so read-only/manual mode stay in sync
            if (selectedNode?.id && node?.data && node.data.hasauth !== appAuth) {
                dispatch(elementUpdated(selectedNode.id, { ...node.data, hasauth: appAuth }, null, null));
            }
        }

        if (app && !url && foundApp) {
            setURL(foundApp.formDataEndpoint);
            if (selectedNode?.id && node?.data) {
                dispatch(elementUpdated(selectedNode.id, {
                    ...node.data,
                    type: foundApp.app,
                    url: foundApp.formDataEndpoint,
                    hasauth: foundApp.auth === true
                }));
            }
            return;
        }

        function getActions() {
            const urlToFetch = resolvedUrl || url;
            setLoadedActions(false);
            axios.request({
                method: "GET",
                url: urlToFetch
            }).then(res => {
                if (isMounted) {
                    setActions(res.data.actions ?? []);
                    setLoadedActions(true);
                }
            }).catch(() => {
                if (isMounted) setLoadedActions(true);
            });
        }

        if (app && (resolvedUrl || url)) {
            setActions([]);
            getActions();
        } else if (app) {
            // App set but no URL (allApps not loaded or app not in list) – stop spinning
            setLoadedActions(true);
        }
        return () => { isMounted = false };
    }, [app, url, allApps])

    // Merge action schema fields with existing node field values so switching to Manual mode preserves AI/user-selected values
    const mergeActionFieldsWithNodeValues = (actionFields, nodeFields) => {
        if (!Array.isArray(actionFields) || !Array.isArray(nodeFields) || nodeFields.length === 0) return actionFields;
        const byName = new Map((nodeFields || []).map((f) => [f?.name, f]));
        return actionFields.map((af) => {
            const existing = byName.get(af?.name);
            if (!existing) return af;
            return { ...af, value: existing.value };
        });
    };

    useEffect(() => {
       
        let isMounted = true;
        if (Object.keys(actions).length > 0 && isMounted && action) { 
            // Load fields from actions when action is set
            // This is the primary way fields are loaded for actions
            const actionFields = action === 'Custom Request' 
                ? globalHttpRequest['workload_http'].fields 
                : actions[action] ? actions[action].fields : undefined;
            
            if (actionFields) {
                // Preserve existing node field values when opening Manual mode (e.g. from read-only); don't overwrite with schema-only
                const nodeFields = node?.data?.fields;
                const merged = (nodeFields && Array.isArray(nodeFields) && nodeFields.length > 0)
                    ? mergeActionFieldsWithNodeValues(actionFields, nodeFields)
                    : actionFields;
                setFields(merged);
            }
        }
        return () => { isMounted = false };
    }, [action, actions])



    //whenever a field is updated, send the change to redux
    // Detect if only fields changed (field mapping) vs other changes (app, event, etc.)
    useEffect(() => {
        // Skip saving if we're currently syncing from Redux (prevents infinite loop)
        if (isSyncingFromReduxRef.current) {
            // Update refs to reflect synced state
            prevFieldsRef.current = fields;
            prevNodeStateRef.current = { name, app, label, icon, hasauth, action, credentialId, authname };
            return;
        }
        
        // Check if only fields changed (field mapping/value change)
        const fieldsChanged = JSON.stringify(prevFieldsRef.current) !== JSON.stringify(fields);
        const otherStateChanged = 
            prevNodeStateRef.current.name !== name ||
            prevNodeStateRef.current.app !== app ||
            prevNodeStateRef.current.label !== label ||
            prevNodeStateRef.current.icon !== icon ||
            prevNodeStateRef.current.hasauth !== hasauth ||
            prevNodeStateRef.current.action !== action ||
            prevNodeStateRef.current.credentialId !== credentialId ||
            prevNodeStateRef.current.authname !== authname;
        
        // Track credential connected when credentialId changes from empty to non-empty
        if (prevNodeStateRef.current.credentialId !== credentialId && 
            credentialId && credentialId !== '' && 
            (!prevNodeStateRef.current.credentialId || prevNodeStateRef.current.credentialId === '')) {
          trackCredentialConnected(label, credentialId);
        }
        
        // Track test data created when testData is set successfully
        if (testData && testData !== '' && 
            (!node?.data?.testData || node.data.testData === '')) {
          trackTestDataCreated('action');
        }
        
        // Track field mapping when fields change
        if (fieldsChanged && !otherStateChanged && fields && fields.length > 0) {
          // Track at least one field mapped
          const mappedFields = fields.filter(f => f.value && f.value !== '');
          if (mappedFields.length > 0) {
            trackFieldMapped(mappedFields[0].name || mappedFields[0].title, mappedFields[0].value, 'action');
          }
        }
        
        if (fieldsChanged && !otherStateChanged) {
            // Only fields changed - save only fields with undo history
            saveFieldsOnly(fields);
            prevFieldsRef.current = fields;
        } else if (otherStateChanged) {
            // Other state changed - save entire node without undo history (undo is handled by explicit user actions)
            // CRITICAL: Don't save if app/type is being cleared (empty/undefined/null)
            // Only save if app has a valid value, or if app didn't change
            const appIsBeingCleared = (prevNodeStateRef.current.app && prevNodeStateRef.current.app !== '') && (!app || app === '');
            if (appIsBeingCleared) {
                // App is being cleared - don't save, just update refs
                prevFieldsRef.current = fields;
                prevNodeStateRef.current = { name, app, label, icon, hasauth, action, credentialId, authname };
            } else {
                // Normal state change - save the node
                saveNode(null);
                prevFieldsRef.current = fields;
                prevNodeStateRef.current = { name, app, label, icon, hasauth, action, credentialId, authname };
            }
        } else {
            // No actual changes detected - just update refs
            prevFieldsRef.current = fields;
            prevNodeStateRef.current = { name, app, label, icon, hasauth, action, credentialId, authname };
        }
    }, [name, app, label, icon, hasauth, action, credentialId, authname, fields])

    useEffect(() => {
        var ticketString = localStorage.getItem("tickets")
        var ticketJSON = ticketString ? JSON.parse(ticketString) : []

       if ( ticketJSON.includes(actions[action]?.title+" Action Incomplete_"+label) === false && app !== null && action !== null && actions[action]?.hasOwnProperty("url") === false) {
           handleSubmitTicket(actions[action]?.title+" Action Incomplete")
       }
    }, [action])

    //refresh a field from redux after making async call (i.e. testNode)
    // Also sync all state from Redux when node changes (e.g., after undo/redo)
    useEffect(() => {
        if (testLoading === true) {
            setTestData(node?.data.testData)
                setTestLoading(false)
        }
      
        // Set flag to prevent save useEffect from firing during Redux sync
        isSyncingFromReduxRef.current = true;
        
        // Sync all state from Redux node data when node changes (including after undo/redo)
        if (node && node.data) {
            if (node.data.name !== name) setName(node.data.name);
            if ((node.data.app || node.data.type) !== app) setApp(node.data.app || node.data.type);
            if (node.data.label !== label) setLabel(node.data.label);
            if (node.data.icon !== icon) setIcon(node.data.icon);
            if (node.data.custombutton !== custombutton) setCustomButton(node.data.custombutton);
            if (node.data.action !== action) setAction(node.data.action);
            if (node.data.actionlabel !== actionlabel) setActionLabel(node.data.actionlabel ?? "");
            if (node.data.credential !== credentialId) setCredentialId(node.data.credential);
            if (node.data.authname !== authname) setAuthname(node.data.authname);
            if (node.data.url !== url) setURL(node.data.url);
            if (node.data.actionTestTime !== actionTestTime) setActionTestTime(node.data.actionTestTime);
            if (node.data.hasauth !== hasauth) setHasAuth(node.data.hasauth);
            if (node.data.testData !== testData) setTestData(node.data.testData);
            
            // Sync fields if they changed
            // IMPORTANT: Only sync fields from node.data if they exist AND are not empty
            // If fields are undefined/null/empty, let the action-based field loading handle it
            if (node.data.fields && Array.isArray(node.data.fields) && node.data.fields.length > 0) {
                var res = node.data.fields.find(item => item.name === 'body');
                const nodeFieldsStr = JSON.stringify(node.data.fields);
                const prevFieldsStr = JSON.stringify(prevFieldsRef.current);
                const fieldsActuallyChanged = nodeFieldsStr !== prevFieldsStr;
                if (loadingperform === true && res && res.schema && Boolean(Object.keys(res.schema.properties).length === 0) === false && fieldsActuallyChanged) {
                    setFields(node.data.fields);
                    prevFieldsRef.current = node.data.fields;
                    // CRITICAL: When fields are updated from perform, ensure type is preserved
                    if ((!node.data.type || node.data.type === '') && app && app !== '') {
                        dispatch(elementUpdated(selectedNode.id, {
                            ...node.data,
                            type: app,
                            fields: node.data.fields
                        }, null, null));
                    }
                } else if (fieldsActuallyChanged) {
                    // Only update when Redux data actually differs from last known (avoids loop after our own save)
                    setFields(node.data.fields);
                    prevFieldsRef.current = node.data.fields;
                    if ((!node.data.type || node.data.type === '') && app && app !== '') {
                        dispatch(elementUpdated(selectedNode.id, {
                            ...node.data,
                            type: app,
                            fields: node.data.fields
                        }, null, null));
                    }
                }
            } else if (!node.data.fields && action && Object.keys(actions).length > 0 && actions[action]) {
                // If node.data.fields is missing/empty but we have an action, load fields from actions
                // This handles the case where AI-generated nodes don't have fields set initially
                const actionFields = actions[action].fields;
                if (actionFields && (!fields || fields.length === 0)) {
                    setFields(actionFields);
                }
            }
        }
        
        // Update refs to reflect synced state
        prevFieldsRef.current = node.data.fields || fields;
        prevNodeStateRef.current = { 
            name: node.data.name, 
            app: node.data.type, 
            label: node.data.label, 
            icon: node.data.icon, 
            hasauth: node.data.hasauth, 
            action: node.data.action, 
            credentialId: node.data.credential, 
            authname: node.data.authname 
        };
        
        // Clear flag after sync completes (use setTimeout to ensure state updates have propagated)
        setTimeout(() => {
            isSyncingFromReduxRef.current = false;
        }, 0);
    }, [node, loadingperform])

    const setNodeNameAuto = (newApp, newAction) => {
        // node.data.name = label + ' - ' + e;
        if (name == 'Add action') {
            setName((newAction ? (newAction + ' in ' + newApp) : ""));
        } 
        else if (newApp === 'Custom Request') {
            setName('Custom Request in ' + label)
        } else if (name == label) {
            setName((newAction ? (newAction + ' in ' + newApp) : ""));
        } else if (!name) {
            setName((newAction ? (newAction + ' in ' + newApp) : ""));
        } else if (name == (label + ' - ' + action)) {
            setName((newAction ? (newAction + ' in ' + newApp) : ""));
        }  else {
            setName((newAction ? (newAction + ' in ' + newApp) : ""));
        }
        // saveNode(node);
    }
const setCustomRequestName = (f) => {
    if (f) {
        let method = null
        let noun = null
        if (f[0].value.requestType === 'GET') {
            method = 'Find a'
        }  if (f[0].value.requestType === 'PUT' || f[0].value.requestType === 'PATCH') {
            method = 'Update a'
        } if (f[0].value.requestType === 'POST') {
            method = 'Create new'
        } if (f[0].value.requestType === 'DELETE') {
            method = 'Remove a'
        } 
        const extractResource = (url) => {
            // Create a URL object to easily access the pathname
            const urlObj = new URL(url);
            const pathParts = urlObj.pathname.split('/'); // Split the pathname by '/'
          
            // Filter out empty strings, variables (e.g. {tenant}), and numeric IDs
            const filteredParts = pathParts.filter(part => part && !part.includes('{') && isNaN(part));
            
            // Assume the resource is the last remaining non-ID, non-variable part
            const resource = filteredParts[filteredParts.length - 1];
          
            // Convert plural resource to singular
            return pluralToSingular(resource);
          };
          
          // Basic plural to singular function
          const pluralToSingular = (word) => {
            if (word.endsWith('ies')) {
              return word.slice(0, -3) + 'y';  // e.g. "companies" -> "company"
            } else if (word.endsWith('es')) {
              return word.slice(0, -2);  // e.g. "boxes" -> "box", "watches" -> "watch"
            } else if (word.endsWith('s')) {
              return word.slice(0, -1);  // e.g. "customers" -> "customer"
            }
            return word; // If it's not plural, return as is
          };
          noun = extractResource(f[0].value.url);
        setName(method + ' ' + noun + ' in ' + label)
    }
}
    const classes = useStyles();

    const resetForm = () => {
        setStep(activeStep - 4)
        // setTestData(null);
    }

    const handleSaveClick = () => {
        dispatch(saveWorkflow(1))
    }

    const sendActionData = (data) => {
        mixpanel.track('Action Select', {
            'action': data
        });
    }

    const sendActionEventData = (data, event) => {
        mixpanel.track('Action Event Selected', {
            'app': data,
            'event': event
        });
    }

    const sendAlert = () => {
        dispatch(alertName({ "severity": "success", "message": node.data.name + " saved successfully" }))
    }
    const [actionsopen, setActionsOpen] = useState(false);


    //format actions for autocomplete search fields
    const actionoptions = actions ?
        Object.entries(actions).map(([k, v]) => {

            const words = k.split(' ');
            const firstLetter = words[0].toUpperCase();
            return {
                label: k,
                firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
                title: v.title,
                hidden: v.hidden,
                description: v.description ?? "",
                group: v.method === "post" ? "CREATE" : v.method === "get" ? "SEARCH" : "UPDATE"
            }
        }) :
        []

    //format actions for autocomplete search fields


  

    function sleep(delay = 0) {
        return new Promise((resolve) => {
            setTimeout(resolve, delay);
        });
    }
    const [appopen, setAppOpen] = useState(false);
    const [appoptions, setAppOptions] = useState([]);
    const [apploading, setAppLoading] = useState()

    useEffect(() => {
        let active = true;

        if (!apploading) {
            return undefined;
        }

        (async () => {
            const response = allApps;
            await sleep(23); // For demo purposes.
            const apps = await response;
            if (active) {
                setAppOptions(Object.keys(apps).map((key) => apps[key]));
                setAppLoading(false)
            }
        })();

        return () => {
            active = false;
        };
    }, [apploading]);

    useEffect(() => {
        if (!appopen) {
            setAppOptions([]);
            setAppLoading(true);
        }
    }, [appopen]);




    const openDropdown = (event) => {
        setAnchorElMenu(event.currentTarget);
    }

    const closeDropdown = (event) => {
        setAnchorElMenu(null);
    }
    const StyledMenu = withStyles({
        paper: {
            border: '1px solid #d3d4d5',
        },
    })((props) => (
        <Menu
            elevation={0}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            {...props}
        />
    ));

    //handling of dropdown menu
    const [anchorElMenu, setAnchorElMenu] = React.useState(null);
    //handling of custom data popper
    const [anchorElPop, setAnchorElPop] = React.useState(null);
    const handlePopClick = (event) => {

        setAnchorElPop(anchorElPop ? null : event.currentTarget);
    };
    const handlePopClose = (event) => {
        setAnchorElPop(null);
    };
    const openpop = Boolean(anchorElPop);
    const id = openpop ? 'simple-popper' : undefined;
    const [poptext, setPopText] = React.useState();

    // Fuzzy matching function for app search
    const fuzzyMatch = (searchText, appText) => {
        if (!searchText || !appText) return false;
        
        // Normalize both strings: lowercase, remove spaces and special characters
        const normalize = (str) => str.toLowerCase().replace(/[^a-z0-9]/g, '');
        const normalizedSearch = normalize(searchText);
        const normalizedApp = normalize(appText);
        
        // If normalized search is empty after normalization, don't match
        if (!normalizedSearch) return false;
        
        // Exact substring match (highest priority)
        if (normalizedApp.includes(normalizedSearch)) return true;
        
        // Check if all characters in search appear in order in app name (character sequence matching)
        // This handles cases like "smrt" matching "smart"
        let searchIndex = 0;
        let firstMatchIndex = -1;
        let lastMatchIndex = -1;
        for (let i = 0; i < normalizedApp.length && searchIndex < normalizedSearch.length; i++) {
            if (normalizedApp[i] === normalizedSearch[searchIndex]) {
                if (firstMatchIndex === -1) {
                    firstMatchIndex = i;
                }
                lastMatchIndex = i;
                searchIndex++;
            }
        }
        // If all characters matched in order, it's a fuzzy match
        if (searchIndex === normalizedSearch.length) {
            const matchSpan = lastMatchIndex - firstMatchIndex + 1;
            
            // Check if app name starts with the search prefix (e.g., "smartemailing" starts with "sma" from "smrt")
            // This is a strong signal that it's a match
            const prefixLength = Math.min(3, normalizedSearch.length);
            const searchPrefix = normalizedSearch.substring(0, prefixLength);
            if (normalizedApp.startsWith(searchPrefix)) {
                // Allow matches that start with the prefix, but still limit the span
                // For "smrt" matching "smartemailing": s(0), m(1), r(2), t(4) -> span is 5
                return matchSpan <= normalizedSearch.length * 2 + 2; // Allow span up to 2x search length + 2
            }
            
            // For matches that don't start with the prefix, be much stricter
            // Only allow if characters are very close together (within 1.5x search length)
            // This catches cases like "smrt" -> "smart" but not "smrt" -> "samcart" (span too long)
            return matchSpan <= normalizedSearch.length * 1.5 + 1;
        }
        
        // Levenshtein distance check for very close matches (only for small differences)
        // Only use this if search and app are similar in length
        if (Math.abs(normalizedSearch.length - normalizedApp.length) <= 2) {
            const levenshteinDistance = (str1, str2) => {
                const matrix = [];
                for (let i = 0; i <= str2.length; i++) {
                    matrix[i] = [i];
                }
                for (let j = 0; j <= str1.length; j++) {
                    matrix[0][j] = j;
                }
                for (let i = 1; i <= str2.length; i++) {
                    for (let j = 1; j <= str1.length; j++) {
                        if (str2.charAt(i - 1) === str1.charAt(j - 1)) {
                            matrix[i][j] = matrix[i - 1][j - 1];
                        } else {
                            matrix[i][j] = Math.min(
                                matrix[i - 1][j - 1] + 1,
                                matrix[i][j - 1] + 1,
                                matrix[i - 1][j] + 1
                            );
                        }
                    }
                }
                return matrix[str2.length][str1.length];
            };
            
            const distance = levenshteinDistance(normalizedSearch, normalizedApp);
            const minLength = Math.min(normalizedSearch.length, normalizedApp.length);
            
            // Only accept if distance is very small relative to the shorter string (max 1-2 char difference)
            // and the shorter string is at least 3 characters (to avoid matching very short strings)
            if (minLength >= 3 && distance <= 2 && distance <= Math.floor(minLength * 0.4)) {
                return true;
            }
        }
        
        return false;
    };

    const allAppsFilterOptions = (options, state) => {
        // Material-UI Autocomplete passes { inputValue, getOptionLabel } as state
        const inputValue = state?.inputValue || '';
        
        if (!inputValue || !inputValue.trim()) {
            return options.slice(0, 50);
        }
        
        const normalizedInput = inputValue.toLowerCase().trim();
        
        // Filter using fuzzy matching
        const filtered = options.filter((option) => {
            const appName = (option.name || '').trim();
            const appTitle = (option.title || '').trim();
            const appCategory = (option.category || '').trim();
            
            // Only check fuzzy match if we have actual text to search
            if (!appName && !appTitle && !appCategory) {
                return false;
            }
            
            // Check fuzzy match against name, title, and category
            return fuzzyMatch(inputValue, appName) || 
                   fuzzyMatch(inputValue, appTitle) || 
                   fuzzyMatch(inputValue, appCategory);
        });
        
        // Sort by relevance: exact matches first, then fuzzy matches
        const sorted = filtered.sort((a, b) => {
            const aName = (a.name || '').toLowerCase();
            const bName = (b.name || '').toLowerCase();
            const searchLower = normalizedInput;
            
            // Prioritize exact substring matches
            const aExact = aName.includes(searchLower);
            const bExact = bName.includes(searchLower);
            if (aExact && !bExact) return -1;
            if (!aExact && bExact) return 1;
            
            // Then prioritize matches that start with search
            const aStartsWith = aName.startsWith(searchLower);
            const bStartsWith = bName.startsWith(searchLower);
            if (aStartsWith && !bStartsWith) return -1;
            if (!aStartsWith && bStartsWith) return 1;
            
            // Then alphabetical
            return aName.localeCompare(bName);
        });
        
        return sorted.slice(0, 50);
    }

    const [tabvalue, setTabValue] = React.useState(1);
    const handleTabChange = (newValue) => {

        setTabValue(newValue);
    };

    const [tabApps, setTabApps] = React.useState();

    useEffect(() => {
        // Remove tabvalue === 0 (Popular) since we're only using All and Tools now
        if (tabvalue === 1) {
            setTabApps(allApps)
        } else if (tabvalue === 2) {
            setTabApps(allApps.filter(item => item.category === 'Utility' && item.trigger === false && item.auth === false))
        } else {
            // Default to All if tabvalue is 0 or unexpected
            setTabApps(allApps)
        }
    }, [tabvalue, allApps])
    
    // Initialize selectedAppObject when component loads or when label/app changes.
    // Do NOT include selectedAppObject in deps: updating it would re-run this effect and can cause
    // "Maximum update depth exceeded" when tabApps/allApps get new references each render.
    useEffect(() => {
      if (!label || !(tabApps ?? allApps)) return;
      const appList = tabApps ?? allApps ?? [];
      const matchingApp = appList.find(appOption =>
        appOption.name === label ||
        appOption.app === app ||
        (appOption.name && label && appOption.name.toLowerCase() === label.toLowerCase())
      );
      setSelectedAppObject((prev) => {
        if (matchingApp) {
          if (prev && prev.name === matchingApp.name && prev.app === matchingApp.app) return prev;
          return matchingApp;
        }
        if (label) {
          const next = { name: label, app: app, icon: icon };
          if (prev && prev.name === next.name && prev.app === next.app) return prev;
          return next;
        }
        return prev;
      });
    }, [label, app, icon, tabApps, allApps]);
    
    // Update recent apps display when it changes
    useEffect(() => {
        // This effect will run when recentAppsUpdated changes, triggering re-render
    }, [recentAppsUpdated])

    useEffect(() => {
        // 👇️ scroll to bottom every time messages change
       // bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [testData]);

    const flattenObj = (ob) => {

        // The object which contains the
        // final result
        let result = {};

        // loop through the object "ob"
        for (const i in ob) {

            // We check the type of the i using
            // typeof() function and recursively
            // call the function again
            if ((typeof ob[i]) === 'object') {
                const temp = flattenObj(ob[i]);
                for (const j in temp) {

                    // Store temp in result
                    result[i.replace('body.', '') + '.' + j] = temp[j];

                }
            }

            // Else store ob[i] in result directly
            else {
                result[i] = ob[i];
            }
        }
        return result;
    };

   
    const [testLoading, setTestLoading] = useState(false)

   
    const handleSentData2 = (e) => {
        // CRITICAL: Blur any active CodeMirror editor to commit its value
        // This ensures the latest typed value is saved before we read it
        const activeElement = document.activeElement;
        let activeEditor = null;
        
        if (activeElement) {
          // Check if activeElement is inside a CodeMirror instance
          const codeMirrorWrapper = activeElement.closest('.CodeMirror');
          if (codeMirrorWrapper && codeMirrorWrapper.CodeMirror) {
            activeEditor = codeMirrorWrapper.CodeMirror;
            try {
              activeEditor.getInputField().blur();
            } catch (err) {
              // Ignore errors
            }
          } else if (activeElement.classList && activeElement.classList.contains('CodeMirror')) {
            if (activeElement.CodeMirror) {
              activeEditor = activeElement.CodeMirror;
              try {
                activeEditor.getInputField().blur();
              } catch (err) {
                // Ignore errors
              }
            }
          }
        }
        
        // Small delay to ensure blur completes and any pending updates are processed
        // But we'll read immediately since CodeMirror updates synchronously
        
        // Find the action-setup container to scope our search
        const actionSetupContainer = document.querySelector('#action-setup');
        const container = actionSetupContainer ? actionSetupContainer.parentElement : document;
        
        // Also try to find the form container more specifically
        const formContainer = container.querySelector('[class*="rjsf"], [class*="form"]') || container;
        
        // Helper to safely escape CSS selectors (for field IDs)
        const escapeSelector = (idValue) => {
          if (!idValue) return '';
          if (typeof CSS !== 'undefined' && CSS.escape) {
            return CSS.escape(idValue);
          }
          return idValue.replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
        };
        
        const getRegisteredEditor = (fieldId) => {
          if (typeof window === 'undefined' || !window.wfCodeMirrorRegistry || !fieldId) return null;
          return window.wfCodeMirrorRegistry[fieldId] || null;
        };
        
        const findEditorByFieldId = (fieldId) => {
          if (!fieldId) return null;
          const escaped = escapeSelector(fieldId);
          const selector = `[data-wf-field-id="${escaped}"] .CodeMirror, .CodeMirror[data-wf-field-id="${escaped}"]`;
          const node = document.querySelector(selector);
          if (node && node.CodeMirror) {
            return node.CodeMirror;
          }
          return null;
        };
        
        // Get all CodeMirror editors within the form area
        // Create a map of editor ID to editor instance for reliable lookup
        // This works even when fields are nested in array templates
        const codeMirrorEditorMap = new Map();
        // Search in both the container and formContainer to be thorough
        const allCodeMirrorElements = [
          ...container.querySelectorAll('.CodeMirror'),
          ...formContainer.querySelectorAll('.CodeMirror')
        ];
        // Remove duplicates
        const uniqueElements = Array.from(new Set(allCodeMirrorElements));
        const codeMirrorEditorsInDomOrder = [];
        uniqueElements.forEach(cm => {
          if (cm.CodeMirror) {
            codeMirrorEditorsInDomOrder.push(cm.CodeMirror);
            // Try multiple ways to find the editor's ID
            // 1. Check the CodeMirror wrapper div itself for id attribute
            let editorId = cm.getAttribute('id');
            // 2. Check for data-wf-field-id attribute (our custom tag)
            if (!editorId) {
              editorId = cm.getAttribute('data-wf-field-id');
            }
            // 3. Check the textarea inside CodeMirror
            if (!editorId) {
              const textarea = cm.querySelector('textarea');
              if (textarea) {
                editorId = textarea.getAttribute('id');
              }
            }
            // 4. Check parent elements (sometimes the ID is on a parent wrapper)
            if (!editorId) {
              let parent = cm.parentElement;
              let depth = 0;
              while (parent && depth < 5) { // Increased depth for nested array fields
                editorId = parent.getAttribute('id') || parent.getAttribute('data-wf-field-id');
                if (editorId) break;
                parent = parent.parentElement;
                depth++;
              }
            }
            // Store in map with all found IDs
            if (editorId) {
              codeMirrorEditorMap.set(editorId, cm.CodeMirror);
              // Also store without array indices for easier matching
              // Array fields often have IDs like "root_0_columnName" or "root_1_columnName"
              const withoutIndex = editorId.replace(/_\d+(_|$)/g, '_').replace(/_$/, '');
              if (withoutIndex !== editorId) {
                codeMirrorEditorMap.set(withoutIndex, cm.CodeMirror);
              }
            }
          }
        });
        
        // Map fields to their CodeMirror editors by ID
        const usedEditors = new Set();
        const updatedFields = e.map((obj, index) => {
          // First, check if the original value is an object with {label, value}
          let extractedValue = null;
          if (typeof obj.value === 'object' && obj.value !== null && !Array.isArray(obj.value) && obj.value.hasOwnProperty('value')) {
            if (typeof obj.value.value === 'string') {
              extractedValue = obj.value.value;
            }
          }
          
          // Skip hidden fields - they don't have CodeMirror editors
          if (obj.hidden === true) {
            return obj;
          }
          
          // Try to find the editor by the field's ID, first via registry
          let editor = getRegisteredEditor(obj.id);
          
          // For array fields, also try registry with common ID patterns
          if (!editor && obj.id) {
            // Array fields might have IDs like "root_0_columnName" but be registered as just the base
            const baseId = obj.id.replace(/^root_\d+_/, '').replace(/_\d+$/, '');
            if (baseId !== obj.id) {
              editor = getRegisteredEditor(baseId);
            }
          }
          
          if (!editor) {
            editor = findEditorByFieldId(obj.id);
          }
          
          if (!editor && obj.id) {
            // Also try finding by base ID (without array indices)
            const baseId = obj.id.replace(/^root_\d+_/, '').replace(/_\d+$/, '');
            if (baseId !== obj.id) {
              editor = findEditorByFieldId(baseId);
            }
          }
          
          if (!editor) {
            // As a fallback, match exact ID with CSS escape
            const escapedId = escapeSelector(obj.id || '');
            if (escapedId) {
              const directSelector = `#${escapedId}.CodeMirror, #${escapedId} .CodeMirror`;
              const node = document.querySelector(directSelector);
              if (node && node.CodeMirror) {
                editor = node.CodeMirror;
              }
            }
          }
          
          // Next fallback: map lookup with exact ID
          if (!editor) {
            editor = obj.id ? codeMirrorEditorMap.get(obj.id) : null;
          }
          
          // For array fields, try ID variations (array fields might have indices)
          if (!editor && obj.id) {
            // Try variations of the ID
            const idVariations = [
              obj.id,
              obj.id.replace(/_\d+$/, ''), // Remove trailing index
              obj.id.replace(/^root_\d+_/, ''), // Remove leading root_0_ pattern
              obj.id.replace(/^root_\d+_/, '').replace(/_\d+$/, ''), // Remove both
              obj.name ? `root_${obj.name}` : null,
              obj.name ? `root_${obj.name.replace(/\./g, '_')}` : null,
              obj.name ? obj.name.replace(/\./g, '_') : null
            ].filter(Boolean);
            
            for (const idVar of idVariations) {
              editor = codeMirrorEditorMap.get(idVar);
              if (editor) break;
              // Also try registry with variations
              if (!editor) {
                editor = getRegisteredEditor(idVar);
                if (editor) break;
              }
            }
          }
          
          if (editor) {
            usedEditors.add(editor);
            try {
              const editorValue = editor.getValue();
              // CodeMirror always returns a string, even if empty
              // Always use the editor value - it's the source of truth and updates synchronously
              // CodeMirror has the latest value, even if React state hasn't updated yet
              // This is critical: when a picker value is selected, CodeMirror is updated immediately
              // but React state may not have updated yet, so we MUST read from CodeMirror
              // Always use the editor value, regardless of whether it's empty or not
              // (empty strings will be filtered out later)
              return { ...obj, value: editorValue };
            } catch (err) {
            }
          } else {
            // For array template fields, the editors are nested inside array items
            // Try to find editors by searching for ones with IDs that contain the field name or match array patterns
            // Array field editors often have IDs like "root_0_fieldName" or "root_1_fieldName"
            if (obj.name) {
              // Try to find editors whose IDs contain this field's name
              const namePattern = new RegExp(obj.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
              const nameMatch = codeMirrorEditorsInDomOrder.find(ed => {
                if (usedEditors.has(ed)) return false;
                try {
                  const wrapper = ed.getWrapperElement && ed.getWrapperElement();
                  if (wrapper) {
                    const editorId = wrapper.getAttribute('id') || wrapper.getAttribute('data-wf-field-id') || 
                                    wrapper.querySelector('textarea')?.getAttribute('id');
                    if (editorId && namePattern.test(editorId)) {
                      return true;
                    }
                    // Also check if it's in a form/label that mentions this field name
                    const parent = wrapper.closest('[class*="field"], [class*="form"], label');
                    if (parent && parent.textContent && parent.textContent.toLowerCase().includes(obj.name.toLowerCase())) {
                      return true;
                    }
                  }
                } catch (e) {}
                return false;
              });
              
              if (nameMatch) {
                usedEditors.add(nameMatch);
                try {
                  const editorValue = nameMatch.getValue();
                  return { ...obj, value: editorValue };
                } catch (err) {
                }
              }
            }
            
            // As a last resort, match to the next unused editor in DOM order
            // This helps with array fields where IDs might not match exactly
            const fallbackEditor = codeMirrorEditorsInDomOrder.find(ed => !usedEditors.has(ed));
            if (fallbackEditor) {
              usedEditors.add(fallbackEditor);
              try {
                const editorValue = fallbackEditor.getValue();
                return { ...obj, value: editorValue };
              } catch (err) {
              }
            } else {
              // If we couldn't find the editor, log for debugging
              // For array template fields, this is expected - they have nested structure
              if (obj.id) {
                const isArrayField = obj.schema && (obj.schema.type === 'array' || (Array.isArray(obj.schema.type) && obj.schema.type.includes('array')));
                if (!isArrayField) {
                  // Only log for non-array fields to reduce noise
                }
              }
            }
          }
          
          // Special handling for array template fields
          // Array fields have nested CodeMirror editors that need to be read from the DOM
          // and their values need to be reconstructed into the array structure
          const isArrayField = obj.schema && (obj.schema.type === 'array' || (Array.isArray(obj.schema.type) && obj.schema.type.includes('array')));
          if (isArrayField && !editor) {
            // For array fields, we need to find all CodeMirror editors within the array's form
            // and read their values to reconstruct the array
            try {
              // Find the form that contains this array field by looking for its title/label
              const arrayFieldTitle = obj.schema?.title || obj.name || '';
              let arrayFormContainer = null;
              
              // Search for forms that contain this array field
              const allForms = formContainer.querySelectorAll('form, [class*="rjsf"]');
              for (const form of allForms) {
                // Check if this form contains a label/title matching our array field
                const labels = form.querySelectorAll('label, [class*="title"], [class*="label"], p, h1, h2, h3, h4, h5, h6');
                for (const label of labels) {
                  const labelText = label.textContent?.trim() || '';
                  if (labelText && (labelText.includes(arrayFieldTitle) || arrayFieldTitle.includes(labelText))) {
                    arrayFormContainer = form;
                    break;
                  }
                }
                if (arrayFormContainer) break;
              }
              
              if (arrayFormContainer) {
                // Find all CodeMirror editors within this array form
                const arrayEditors = Array.from(arrayFormContainer.querySelectorAll('.CodeMirror'))
                  .filter(cm => cm.CodeMirror && !usedEditors.has(cm.CodeMirror))
                  .map(cm => cm.CodeMirror);
                
                // If we found editors, we need to read their values
                // But array fields have complex nested structure, so we'll rely on the form's onChange
                // to have already updated the value. However, we should ensure the latest CodeMirror values
                // are committed. The form's onChange should handle this, but let's make sure by
                // triggering a blur on all array editors
                arrayEditors.forEach(ed => {
                  try {
                    ed.getInputField().blur();
                  } catch (e) {}
                });
                
                // The array value should already be updated via the form's onChange
                // So we can just return the existing value, which should have the latest data
                // But let's make sure we're not missing anything by checking if there are new values
                return obj;
              }
            } catch (err) {
            }
          }
          
          // Fallback: If we extracted a value from an object, use it
          if (extractedValue !== null) {
            // If original was an object, preserve structure
            if (typeof obj.value === 'object' && obj.value !== null && !Array.isArray(obj.value) && obj.value.hasOwnProperty('value')) {
              return { ...obj, value: { ...obj.value, value: extractedValue } };
            }
            return { ...obj, value: extractedValue };
          }
          
          // Final fallback: use the field's existing value
          return obj;
        });
        
        let results = updatedFields
        .filter(obj =>
          obj.value !== undefined &&
          obj.value !== "" &&
          obj.hidden !== true
        )
        .map(obj => {
          // Double-check: If obj.value is still an object after extraction, handle it
          if (typeof obj.value === 'object' && obj.value !== null && !Array.isArray(obj.value)) {
            // For dynamic fields stored as {label, value}, extract the string value
            // Check if it's a dynamic field object (has 'value' property that's a string)
            if (obj.value.hasOwnProperty('value') && typeof obj.value.value === 'string') {
              // Extract the string value (which may contain ${...} references)
              return { ...obj, value: obj.value.value };
            }
            // For other objects (like body fields), filter its key/value pairs
            const filteredValue = Object.fromEntries(
              Object.entries(obj.value).filter(([key, value]) => value !== undefined && value !== "")
            );
            // Return a new object with the filtered value.
            return { ...obj, value: filteredValue };
          }
          return obj;
        });
      
      
       
        var checkrefs = flattenObj(results.reduce((acc, cur) => ({ ...acc, [cur.name]: cur.value }), {}))
        const widgetRe =  /\${(([^}][^}]?|[^}]}?)*)}/ig;
        

        for (const property in checkrefs) {
            // Skip if property value is null, undefined, or not a valid value
            if (checkrefs[property] === null || checkrefs[property] === undefined) {
                continue;
            }
            
            // Safely convert to string and check for template references
            const propertyValue = checkrefs[property];
            const valueString = propertyValue != null ? String(propertyValue) : '';
            
            if (valueString.includes('${')) {
                const matcharray = [...valueString.match(widgetRe)];
                matcharray.map((item) => {
                    
                    var splitprop = item.split(".")
                    var nodelook = splitprop[1]
                    var nodekey = splitprop.slice(-1)
                    var nodekey_concat = nodekey.join('.')
                    var clean = nodekey_concat.replace("}", "")
                    var getvalue = workflow[nodelook].outputFields
                   
                  const recursiveSearch = (obj, searchKey, results = []) => {
                    const r = results;
                    if (obj) {
                    Object.keys(obj).forEach(key => {
                       const value = obj[key];
                       
                       if(key === searchKey && typeof value !== 'object'){
                          r.push(value);
                       }
                       else if (key === searchKey && Array.isArray(value)) {
                        r.push(JSON.stringify(value).substring(0, 250) + "...");
                    } 
                       else if(typeof value === 'object'){
                          recursiveSearch(value, searchKey, r);
                       }
                      
                    })};
                    return r;
                 };
                 const replaced_value = recursiveSearch(getvalue, clean)[0];
               //('replaced value:: ', replaced_value)
                    const cleanref = checkrefs[property].replaceAll(item, replaced_value)
                    checkrefs[property] = cleanref
                    
                })
                
                
               // checkrefs[property] = cleanref

              
            }
            if (property.includes('body.')) {
                var new_prop = property.replace('body.', '')
                checkrefs[new_prop] = checkrefs[property];
                delete checkrefs[property]
            }
        }
       
        // Final cleanup: remove empty strings, null, undefined, and empty objects/arrays
        const cleanedCheckrefs = {};
        for (const key in checkrefs) {
            const value = checkrefs[key];
            // Skip undefined, null, and empty strings
            if (value === undefined || value === null || value === '') {
                continue;
            }
            // Skip empty objects
            if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
                continue;
            }
            // Skip empty arrays
            if (Array.isArray(value) && value.length === 0) {
                continue;
            }
            // Include the value
            cleanedCheckrefs[key] = value;
        }
       
        setSentData(cleanedCheckrefs)

    }

    const handleSubmitTicket = (reason,) => {
       
        const email = localStorage.getItem('email')
     
        mixpanel.track('Support Ticket Created', {
            'Email': email ? email : 'undefined',
              'App': app,
              'Title': label + " "+reason,
              'Label': label,
              'Decription': "When I use "+label+" there is a problem: "+reason
          });
           let config_send = {
            method: 'post',
            url: 'https://editor.workload.co:5000/createTicket',
            headers: { 
                
                'Content-Type': 'application/json'
            },
            data: {
              editor_url: window.location.href,
              tenantId: tenant,
              email: email,
              title: label + " "+reason,
              content: "When I use "+label+" there is a problem: "+reason,
              app: label,
              event: actions ? actions[action]?.title : ""
            }
          }
          
      
            axios(config_send)
            .then((response) => {
           var ticketString = localStorage.getItem("tickets")
           var ticketJSON = ticketString ? JSON.parse(ticketString) : []
           ticketJSON.push(reason+"_"+label)
           function removeDuplicates(arr) { 
              return [...new Set(arr)]; 
          } 
          var newTicketJSON = removeDuplicates(ticketJSON)
          let ticketstring = JSON.stringify(newTicketJSON) 
          localStorage.setItem("tickets", ticketstring) 
           
      
      })
      .catch((error) => {
     
      });
      
        }


    useEffect(() => {
        var ticketString = localStorage.getItem("tickets")
         var ticketJSON = ticketString ? JSON.parse(ticketString) : []
      
        if ( actionsopen === true  && app && actionoptions && actionoptions.length === 0 && ticketJSON.includes("Action Dropdown Empty_"+label) === false && loadedActions === true ) {
            handleSubmitTicket("Action Dropdown Empty")
        }
      }, [actionsopen, loadedActions])

    const PaperComponentCustom = options => {

        const { containerProps, children } = options;
        return (
            <Paper {...containerProps} style={{ fontWeight: 600, padding: 4, backgroundColor: theme.palette.background.paper }}>
                {children}

                <div>
                    <br />
                    <Divider /><br />

                    <Typography variant='body2' align='center' style={{ color: 'gray' }}>Can't find the <span style={{ padding: 4, alignItems: 'baseline', fontWeight: 300, fontSize: '16px', border: '1px solid gray', borderRadius: '4px' }}><div style={{ display: 'inline-flex', alignItems: 'flex-end', marginLeft: '0px', marginTop: '4px', padding: '0px 0px 0px 0px' }} ><img src={icon} style={{ height: '25px', width: '25px', marginBottom: '-6px', paddingRight: '4px', position: 'absolute' }} /></div><div style={{ display: 'inline-flex', marginLeft: '29px' }}>{label}</div></span> action you're searching for?</Typography><br />
                </div>
                <div style={{ justifyContent: 'center', display: 'flex' }}>
                    <Button variant='contained'
                        style={{ textTransform: 'none', backgroundColor: 'black', color: 'white', fontWeight: 600, marginBottom: '10px' }}
                        onMouseDown={() => {
                            var custom = globalHttpRequest['workload_http']
                            setFields(null); setFields(custom.fields); setNodeNameAuto(custom.title); setAction(custom.title); setActionLabel(custom.title); saveNode('changed event'); setStep(activeStep + 1);
                        }}
                    >
                        + Create custom action
                    </Button></div>

            </Paper>
        );
    };



    

    const panelWrapStyle = inlineLayout ? { position: 'relative', width: '100%', height: '100%', minHeight: 0, overflow: 'auto', paddingLeft: 6, paddingRight: 12 } : {};
    const mainPanelClassName = inlineLayout ? undefined : styles.Panel;
    try {
        return (
            node ?
                <div className={mainPanelClassName} style={{ paddingTop: '75px', maxWidth: '100%', minWidth: 0, overflow: 'hidden', ...panelWrapStyle }}>
                    <div id='header-top' style={{ backgroundColor: theme.palette.background.default }}>
                        <div id="headerbox" className={classes.headerbox}>
                            <div style={{ marginLeft: '8px', display: 'block', padding: 0, position: 'absolute', top: 0, right: 0, justifyContent: 'center', alignItems: 'center', marginRight: '12px', marginTop: '75px' }}>
                                <IconButton  style={{  borderRadius: 50, padding: 2, float: 'right' }} aria-label="close modal" onClick={() => { saveNode('updated step'); handleSaveClick(); onPaneClick() }}>
                                    <HighlightOffRoundedIcon fontSize={breakpoint !== 'large' ? 'small' : 'medium'} />
                                </IconButton><br />
                                <IconButton  style={{ marginTop: breakpoint === 'small' ? '0px' : '8px', borderRadius: 50, padding: 1, float: 'right' }} aria-label="menu-context" onClick={openDropdown}>
                                    <MoreHorizRoundedIcon fontSize={breakpoint !== 'large' ? 'medium' : 'large'} />
                                </IconButton>
                            </div>
                            <StyledMenu
                                id="customized-menu"
                                anchorEl={anchorElMenu}
                                keepMounted
                                open={Boolean(anchorElMenu)}
                                onClose={closeDropdown}
                            >
                                <MenuItem onClick={() => { onPaneClick(); dispatch(elementDeleted(selectedNode.id)); handleSaveClick() }}>
                                    <ListItemIcon>
                                        <DeleteForeverRoundedIcon fontSize="small" color="secondary" />
                                    </ListItemIcon>
                                    <ListItemText style={{ marginRight: 20 }} primary="Delete Step" />
                                </MenuItem>
                            </StyledMenu>
                            {icon ?
                                <img style={{ width: breakpoint !== 'large' ? '36px' : '48px', height: breakpoint !== 'large' ? '36px' : '48px', float: 'left', boxShadow: '-1px 2px 3px 2px silver', borderRadius: '50%', marginLeft: breakpoint !== 'large' ? '5px' : null }} src={icon} />
                                : <Avatar style={{ marginRight: '10px', float: 'left', }}>
                                    <AppsRoundedIcon />
                                </Avatar>
                            }
                            <Input startAdornment={
                                <InputAdornment position="start">
                                    <CreateRoundedIcon style={{ color: 'silver', fontSize: breakpoint !== 'large' ? '14px' : null }} />
                                </InputAdornment>
                            } style={{ width: breakpoint === 'small' ? '175px' : null, marginTop: '5px', marginLeft: breakpoint !== 'large' ? '8px' : '16px', minWidth: breakpoint !== 'large' ? '50%' : '75%', fontSize: breakpoint !== 'large' ? '16px' : '24px', fontWeight: 'bold' }} id="name" onChange={e => { 
                                setName(e.target.value); saveNode('renamed step'); handleSaveClick(); }} defaultValue={node.data.name} value={node.data.name === 'Choose an Action' ? 'Name this Step' : name} placeholder="Name this step..." />

                        </div>
                        <div style={{ float: 'clear', marginBottom: '20px' }}></div>
                    </div>
                    <Divider />
                    <Stepper style={{ borderRadius: '0px 0px 8px 8px', padding: inlineLayout ? '24px 12px 8px 6px' : '24px 8px 8px 0px' }} activeStep={activeStep} orientation='vertical' connector={<div style={{height:'20px', borderBottom: '1px solid lightgray', marginBottom:'25px' }} />}>
                        <Step key="App Step" >
                           {activeStep === 0 && !app ? <StepButton icon={<WarningRounded style={{color: 'orange'}} />} onClick={(e) => { setStep(0) }}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>App</strong></Typography><Carat active={activeStep === 0 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> : <StepButton onClick={(e) => { setStep(0) }}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>App</strong></Typography><Carat active={activeStep === 0 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton>   }
                            <StepContent style={{ paddingLeft: '8px', marginLeft: '8px', borderLeft: 'none' }}>
                                <br />
                                <Paper className={classes.tabs} elevation={0}>
                                    <div style={{ marginBottom: 15, display: 'flex', justifyContent: 'flex-start' }}>
                                        <ButtonGroup size="small" variant="outlined" aria-label="filter apps" disableElevation color="primary">
                                            <Button 
                                                variant={tabvalue === 1 ? "contained" : "outlined"}
                                                onClick={() => handleTabChange(1)}
                                                startIcon={<AppsRoundedIcon style={{ fontSize: '16px' }} />}
                                            >
                                                All
                                            </Button>
                                            <Button 
                                                variant={tabvalue === 2 ? "contained" : "outlined"}
                                                onClick={() => handleTabChange(2)}
                                                startIcon={<BuildRoundedIcon style={{ fontSize: '16px' }} />}
                                            >
                                                Tools
                                            </Button>
                                        </ButtonGroup>
                                    </div>

                                    {/* Popular Built In Tools */}
                                    <div style={{ marginBottom: '16px' }}>
                                        <Typography variant="body2" style={{ fontWeight: 600, marginBottom: '8px', fontSize: '12px', color: '#666', textTransform: 'none', letterSpacing: '0.5px' }}>
                                            Popular Built In Tools
                                        </Typography>
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                            {(() => {
                                                // Find Utility category apps that are not triggers and don't require auth (internal built-in tools)
                                                const utilityApps = allApps.filter(item => item.category === 'Utility' && item.trigger === false && item.auth === false);
                                                const popularTools = [
                                                    'AI Wizard by Workload',
                                                    'Date Format',
                                                    'Array Functions',
                                                    'HTTP Request'
                                                ];
                                                return popularTools.map(toolName => {
                                                    const toolApp = utilityApps.find(app => app.name === toolName);
                                                    if (!toolApp) return null;
                                                    return (
                                                        <Chip
                                                        size="small"
                                                        variant="outlined"
                                                        
                                                            key={toolApp.name}
                                                            avatar={<Avatar src={toolApp.icon} style={{ width: '20px', height: '20px' }} />}
                                                            label={toolApp.name}
                                                            onClick={() => handleChipClick(toolApp)}
                                                            style={{ 
                                                                cursor: 'pointer',
                                                                fontSize: '13px',
                                                                fontWeight: 500
                                                            }}
                                                        />
                                                    );
                                                });
                                            })()}
                                        </div>
                                    </div>

                                    <FormControl variant="outlined" style={{ width: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex', margin: 'auto'}} >
                                        <Autocomplete
                                            autoComplete
                                            id="action-combo-box-demo"
                                            options={tabApps ?? allApps}
                                            value={selectedAppObject || null}
                                            open={appopen}
                                            filterOptions={allAppsFilterOptions}
                                            onOpen={() => {
                                                setAppOpen(true);
                                            }}
                                            onClose={() => {
                                                setAppOpen(false);
                                            }}
                                            onChange={(e, v) => { 
                                                if (v === null) {
                                                    // Don't allow clearing the app - keep the current selection
                                                    // Just close the dropdown without changing anything
                                                    setAppOpen(false);
                                                    return;
                                                } else {
                                                    // Update selected app object immediately
                                                    setSelectedAppObject(v);
                                                    
                                                    // Clear all related state when app changes
                                                    setAppChanged(true);
                                                    setAction('');
                                                    setActionLabel('');
                                                    setAuthname('');
                                                    setCredentialId('');
                                                    setTestData(null);
                                                    
                                                    // Update app-related state
                                                    setApp(v.app);
                                                    setLabel(v.name);
                                                    setIcon(v.icon);
                                                    setCustomButton(v.custombutton);
                                                    setURL(v.formDataEndpoint);
                                                    // Set hasauth based on app's auth property
                                                    setHasAuth(v.auth === true);
                                                    
                                                    // Track app selected
                                                    trackAppSelected(v.name, v.app, 'action');
                                                    
                                                    // Update node name - set to default first, then update
                                                    setName('Add action');
                                                    setNodeNameAuto(v.name, undefined);
                                                    
                                                    // Save the changes with description
                                                    saveNode('changed app');
                                                    
                                                    // Save to recent apps
                                                    saveRecentApp(v, 'action');
                                                    setRecentAppsUpdated(Date.now());
                                                }
                                            }}
                                            loading={apploading}
                                            getOptionSelected={(option, value) => {
                                                if (!value) return false;
                                                if (typeof value === 'string') {
                                                  return option.name === value || option.title === value;
                                                }
                                                return option.name === value.name && option.app === value.app;
                                              }}
                                            getOptionLabel={(option) => option.name ?? label}
                                            groupBy={(option) => option.group.length > 0 ? option.group : option.category}
                                            style={{ width: '100%', height: '60px' }}
                                            renderOption={(option) => (
                                                <li style={{ listStyleType: 'none', padding: 2 }} id={option.name} key={option.name}>
                                                    <Box display="flex">
                                                        <Box style={{float: 'left'}}>
                                                        <Avatar style={{ padding: '4px', width: '32px', height: '32px', marginRight: '10px', float: 'left' }} src={option.icon} />
                                                    </Box>
                                                    <Typography style={{marginTop: '5px', fontWeight: 'bold', fontSize: '20px'}}>{option.name}</Typography>
                                                    </Box>
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <div style={{ position: "relative", width: '100%' , marginTop: '10px'}}>
                                                    {params.inputProps.value && (

                                                        <span>
                                                            {/* Write logic to have Icon from params.inputProps.value */}
                                                            {<Avatar style={{
                                                                position: "absolute",
                                                                transform: "translateY(40%)",
                                                                marginLeft: "10px",
                                                                width: '32px', height: '32px', marginRight: '30px'
                                                            }} src={icon} />}
                                                        </span>
                                                    )}
                                                    <TextField
                                                        autoFocus={true}
                                                        {...params}
                                                        label="Type to search for an App"
                                                        variant="outlined"
                                                        inputProps={{
                                                            ...params.inputProps,
                                                            autoComplete: "off",
                                                            style: { paddingLeft: "45px", width: '100%' } // disable autocomplete and autofill
                                                        }}
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <React.Fragment>
                                                                    {allApps.length === 0 ? <CircularProgress style={{ marginRight: 20 }} color={colors[color]} size={30} /> : null}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            )

                                                        }}
                                                    />
                                                </div>
                                            )}
                                        />

                                    </FormControl>
                                    
                                    {/* Recent Apps */}
                                    {recentApps.length > 0 && (
                                        <div style={{ marginTop: '14px', marginBottom: '4px' }}>
                                            <Typography variant="body2" style={{ fontWeight: 600, marginBottom: '8px', fontSize: '12px', color: '#666', textTransform: 'none', letterSpacing: '0.5px' }}>
                                                Recent Apps
                                            </Typography>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                                {recentApps.map((appObj, index) => (
                                                    <Chip
                                                    size="small"
                                                    variant="outlined"
                                                        key={`${appObj.name}-${index}`}
                                                        avatar={<Avatar src={appObj.icon} style={{ width: '20px', height: '20px' }} />}
                                                        label={appObj.name}
                                                        onClick={() => handleChipClick(appObj)}
                                                        style={{ 
                                                            cursor: 'pointer',
                                                            fontSize: '13px',
                                                            fontWeight: 500
                                                        }}
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </Paper>
                                <br /><br />
                                <div className={classes.actionsContainer}>
                                    <div>
                                        <Button style={{ width: '100%', textTransform: 'none', fontWeight: '600', fontSize: breakpoint !== 'large' ? '14px' : '18px' }} disabled={app ? 0 : 1} variant="contained" color="primary" onClick={e => { saveNode('updated step'); setStep(activeStep + 1); }}>Continue</Button>
                                    </div>
                                </div>
                            </StepContent>
                        </Step>

                        <Step key='Action Step' disabled={app ? 0 : 1}>

                           {activeStep === 1 && !action ? <StepButton icon={<WarningRounded style={{color: 'orange'}} />} onClick={(e) => { setStep(1) }}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Event</strong></Typography><Carat active={activeStep === 1 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> : <StepButton onClick={(e) => { setStep(1) }}><div><Typography style={{ fontSize: '18px', display: 'block', float:'left' }}><strong>Event</strong></Typography><Carat active={activeStep === 1 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> }
                            <StepContent style={{ paddingLeft: '8px', marginLeft: '8px', borderLeft: 'none' }}>

                                {actions ?

                                    <Autocomplete
                                        autoComplete
                                        freeSolo={true}
                                        id="choose-action"
                                        open={actionsopen}
                                        value={action ?? ''}
                                        onOpen={() => {
                                            setActionsOpen(true);
                                        }}
                                        onClose={(e, reason) => {
                                            
                                            setActionsOpen(false);
                                        }}
                                        loading={!loadedActions}
                                        loadingText={"Loading Actions..."}
                                        noOptionsText={"Looks like Workload doesn't have any actions. You can still use this app with Custom Actions (below)."}
                                        options={actionoptions.filter(item => item.hidden !== true).sort((a, b) => a.group.localeCompare(b.group))}
                                        groupBy={(option) => option.group}
                                        getOptionLabel={(option) =>  option.title ?? option.label ?? actionlabel }
                                        getOptionSelected={(option, value) => {
                                            if (typeof value === 'string') {
                                              // When value is a string (freeSolo), compare it to option's label or title
                                              return option.label === value || option.title === value;
                                            }
                                            return option.label === value.label;
                                          }}
                                        onChange={(e, v) => { 
                                            if (v === null) {
                                                v = "";
                                            } else if (v === action) {
                                                setStep(activeStep +1);
                                            } else {
                                                setEventChanged(true); 
                                                setNodeNameAuto(label, v.title ?? v.label); 
                                                setAction(v.label); 
                                                setActionLabel(v.title ?? v.label);
                                                sendActionEventData(app, v.label); 
                                                // Track event selected
                                                trackEventSelected(label, v.title ?? v.label, 'action');
                                                saveNode('changed event'); 
                                            }
                                        }}
                                        style={{ width: '100%' }}
                                        PaperComponent={PaperComponentCustom}
                                        renderOption={(option) => (
                                            <li style={{ listStyleType: 'none', padding: 4 }} id={option.title} key={option.label}>
                                                <Typography style={{ fontWeight: 'bold', fontSize: '20px' }}>{option.title ?? option.label}</Typography>
                                                <Typography style={{fontWeight: 300, fontSize: '16px' }}>{option.description}</Typography>
                                            </li>
                                        )}
                                        renderInput={(params) => <TextField {...params} label={breakpoint === 'small' ? 'Actions' : 'Click for actions'} variant="outlined"
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <React.Fragment>
                                                        {!loadedActions ? <CircularProgress color={colors[color]} size={20} /> : null}
                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                ),
                                            }} />}

                                    /> :
                                    null
                                }

                                <div className={classes.actionsContainer}>
                                    <div><br />
                                        
                                        <Button style={{ width: breakpoint !== 'large' ? '100%' : '100%',  textTransform: 'none', fontWeight: '600', fontSize: breakpoint !== 'large' ? '14px' : '18px' }} disabled={action ? 0 : 1} variant="contained" color="primary" onClick={e => { setStep(activeStep + 1); saveNode() }}>Continue</Button>
                                    </div>
                                </div>
                            </StepContent>
                        </Step>

                        {hasauth === true ?
                            <Step key='Auth Step' disabled={action && hasauth ? 0 : 1}>
                              {hasauth === true && !credentialId || hasauth === true && credentialId === "" ? <StepButton icon={<WarningRounded style={{color: 'orange'}}/>} onClick={(e) => { setStep(2) }}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Account</strong></Typography><Carat active={activeStep === 2 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> : <StepButton onClick={(e) => { setStep(2) }}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Account</strong></Typography><Carat active={activeStep === 2 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> }
                                <StepContent style={{ paddingLeft: '8px', marginLeft: '8px', borderLeft: 'none' }}>
                                    <Authorizer
                                        user={user}
                                        sendLoggedOutToAuthorizer={sendLoggedOutToAuthorizer}
                                        tenant={tenant}
                                        node={node}
                                        app={app}
                                        applabel={label}
                                        icon={icon}
                                        sendData={setCredentialId}
                                        sendAuth={setAuthname}
                                        saveNode={saveNode}
                                        value={authname}
                                        breakpoint={breakpoint}
                                        custombutton={custombutton}
                                    />
                                    <div className={classes.actionsContainer}>
                                        <div><br />
                                            
                                            <Button style={{ width: '100%', textTransform: 'none', fontWeight: '600', fontSize: breakpoint !== 'large' ? '14px' : '18px' }} disabled={credentialId ? 0 : 1} variant="contained" color="primary" 
                                            onClick={e => { saveNode(); handleSaveClick(); setStep(activeStep + 1) }}>Continue</Button>
                                        </div>
                                    </div>

                                </StepContent>
                            </Step> :
                            null}

                        <Step key='Set-up Step' disabled={action && (!hasauth || (hasauth && authname)) ? 0 : 1}>
                           {fields && fields.some(e => e.value) === false ? <StepButton icon={<WarningRounded style={{color: 'orange'}} />} onClick={(e) => { hasauth ? setStep(3) : setStep(2) }}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Action</strong></Typography><Carat active={hasauth && activeStep === 3 ? true : !hasauth && activeStep === 2 ? true : false } style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> : <StepButton onClick={(e) => { hasauth ? setStep(3) : setStep(2) }}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Action</strong></Typography><Carat active={hasauth && activeStep === 3 ? true : !hasauth && activeStep === 2 ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> }
                            <StepContent style={{ paddingLeft: '8px', marginLeft: '8px', borderLeft: 'none', position: 'relative', display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 400px)', overflow: 'hidden', minWidth: 0 }}>
                                <div style={{ position: 'sticky', top: 0, zIndex: 100, backgroundColor: theme.palette.background.paper, paddingBottom: '8px', flexShrink: 0, minWidth: 0 }}>
                                    <Alert severity='info' style={{ marginBottom: '12px' }}>
                                        <Typography style={{ fontSize: '14px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                            <strong>Open the field mapper menu </strong> by clicking 
                                            <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '20px', height: '20px', backgroundColor: theme.palette.background.paper, border: '1px solid #ddd', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', margin: '0 4px' }}>
                                                <AddRoundedIcon style={{ fontSize: '14px', color: '#666' }} />
                                            </span>
                                            next to a field.
                                        </Typography>
                                    </Alert>
                                </div>
                                <div style={{ flex: '1 1 auto', overflowY: 'scroll', overflowX: 'hidden', minHeight: 0, minWidth: 0, paddingBottom: '100px', maxHeight: 'calc(100vh - 600px)' }}>
                                    <FieldsRender breakpoint={breakpoint} fields={fields} setFields={handleSetFields} parentTree={parentTree} nodeID={node.id} disabled={false}  />
                                    <div id='action-setup' style={{ width: '100%', maxWidth: '100%', minWidth: 0 }}></div>
                                </div>

                                <div style={{ position: 'absolute', bottom: 0, left: '8px', right: '8px', backgroundColor: theme.palette.background.paper, zIndex: 1000, paddingTop: '16px', paddingBottom: '16px' }}>
                                    <Button disabled={loadingperform ? 1 : 0 || !areRequiredFieldsFilled()} style={{ width: '100%',  textTransform: 'none', fontWeight: '600', fontSize: breakpoint !== 'large' ? '14px' : '18px' }} variant="contained" color="primary" onClick={e => { 
                                        // Blur any active field to commit its value before reading
                                        const activeEl = document.activeElement;
                                        if (activeEl && activeEl.blur) {
                                          activeEl.blur();
                                        }
                                        // Also blur any CodeMirror input field
                                        const codeMirrorInput = activeEl?.closest('.CodeMirror')?.CodeMirror?.getInputField();
                                        if (codeMirrorInput && codeMirrorInput.blur) {
                                          codeMirrorInput.blur();
                                        }
                                        // Also blur all CodeMirror editors to ensure values are committed
                                        const allCodeMirrors = document.querySelectorAll('.CodeMirror');
                                        allCodeMirrors.forEach(cm => {
                                          if (cm.CodeMirror) {
                                            try {
                                              cm.CodeMirror.getInputField().blur();
                                            } catch (err) {
                                              // Ignore errors
                                            }
                                          }
                                        });
                                        
                                        // For array template fields, ensure form onChange handlers have fired
                                        // by triggering change events on all RJSF forms
                                        const allForms = document.querySelectorAll('form, [class*="rjsf"]');
                                        allForms.forEach(form => {
                                          try {
                                            // Trigger change event to ensure form processes pending updates
                                            if (form.dispatchEvent) {
                                              const changeEvent = new Event('change', { bubbles: true, cancelable: true });
                                              form.dispatchEvent(changeEvent);
                                            }
                                          } catch (e) {
                                            // Fallback for older browsers
                                            try {
                                              const changeEvent = document.createEvent('Event');
                                              changeEvent.initEvent('change', true, true);
                                              form.dispatchEvent(changeEvent);
                                            } catch (e2) {
                                              // Ignore if both fail
                                            }
                                          }
                                        });
                                        
                                        // Small delay to ensure blur completes, form onChange fires, and values are committed
                                        // Also ensure CodeMirror has time to update after handleDynamicValueChange
                                        // Increased delay slightly for array fields
                                        setTimeout(() => {
                                          handleSentData2(fields);
                                          setShowTestData(true);  
                                          setCustomRequestName(actionlabel === 'Custom Request' ? fields : null);
                                          saveNode(); 
                                          handleSaveClick(); 
                                          setStep(activeStep + 1); 
                                        }, 150);
                                      }}>
                                            {loadingperform ? <CircularProgress color={colors[color]} size={25} /> : hasauth === true ? 'Continue' : 'Continue'}</Button>
                                </div>


                            </StepContent>
                        </Step>
                       
                        <Step key='Test Step' disabled={action && (!hasauth || (hasauth && authname)) ? 0 : 1}>
                           { !testData ?? testData === "" ? <StepButton icon={<WarningRounded style={{color: 'orange'}} />} onClick={(e) => {saveNode(); handleSaveClick(); setStep(testStep); handleSentData2(fields); setShowTestData(true) }}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Test</strong></Typography><Carat active={activeStep === testStep || activeStep === finalStep ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> : <StepButton onClick={(e) => {saveNode(); handleSaveClick(); setStep(testStep); handleSentData2(fields); setShowTestData(true) }}><div><Typography style={{ fontSize: '18px', display: 'block', float: 'left' }}><strong>Test</strong></Typography><Carat active={activeStep === testStep || activeStep === finalStep ? true : false} style={{display:'block', float: 'left', fontSize: '30px'}} /></div></StepButton> }
                            <StepContent style={{ paddingLeft: '8px', marginLeft: '8px', borderLeft: 'none' }}>
                                <br />
                                <div style={{ marginBottom: '16px' }}>
                                    <Typography style={{ fontWeight: 'bold', fontSize: breakpoint === 'small' ? '14px' : '18px', marginBottom: '12px' }}>{actionlabel ?? action} in {label}?</Typography>
                                </div>
                                <div style={{ marginBottom: '16px' }}>
                                    {icon ? 
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <img style={{ width: breakpoint === 'small' ? '36px' : '48px', height: breakpoint === 'small' ? '36px' : '48px', marginRight: '8px' }} src='https://cdn.workload.co/wp-content/uploads/workload-icon.png' />
                                            <img style={{ width: breakpoint === 'small' ? '36px' : '48px', height: breakpoint === 'small' ? '36px' : '48px', marginRight: '8px' }} src='https://cdn.workload.co/wp-content/uploads/connection-animated.gif' />
                                            <img style={{ width: breakpoint === 'small' ? '36px' : '48px', height: breakpoint === 'small' ? '36px' : '48px' }} src={icon} />
                                        </div>
                                        : <Avatar style={{ marginRight: '10px' }}>
                                            <AppsRoundedIcon />
                                        </Avatar>
                                    }
                                </div>
                                <div style={{ marginBottom: '20px' }}>
                                    <Typography style={{ fontWeight: 300, fontSize: breakpoint === 'small' ? '14px' : '16px', color: '#666', lineHeight: '1.4' }}>This is the sample data we will send to <strong>{label}</strong>.</Typography>
                                </div>
                                <div style={{ display: 'in-line', marginTop: '20px' }}>
                                    {showTestData === true ? fields ? sentData ? 
                                    <div style={{ float: 'left', width: '100%', maxHeight: '350px', overflowX: 'hidden', overflowY: 'scroll', marginBottom: '25px' }}>
                                        <DataInspector data={sentData} testData={node.data.testData} />
                                        </div> 
                                        : null : null : null
                                    }
                                </div>
                                <div id='actions-test' className={classes.actionsContainer}>
                                    <div>
                                        <Button onClick={e => { sendNode(node); saveNode(); handleSaveClick(); onPaneClick() }} variant="outlined" style={{ textTransform: 'none', fontSize: '18px' }}>Skip test</Button>
                                        <Button style={{marginLeft: '20px', textTransform: 'none', fontSize: '18px' }} variant="contained" color="primary" onClick={() => {setTestLoading(true); testNodeClick()  }}>Test action</Button>
                                    </div>
                                </div>
                            </StepContent>
                        </Step>

                    </Stepper>

                    <div style={{ width: '90%', height: '1px' }}></div>
                    {activeStep === finalStep && (
                        <Paper square elevation={0} className={classes.resetContainer}>

                            { testLoading === true  ?
                                <Fragment>
                                    <Alert severity="info">
                                        <AlertTitle>Waiting for response data</AlertTitle>
                                        Sending a test to {actionlabel} in <strong>{label}</strong><br /><br />
                                    </Alert><CircularProgress style={{ marginLeft: '40px' }} id='circularprogresscolor' color={colors[color]} size={50} />
                                </Fragment>
                                : testData && testData.hasOwnProperty("error") || testData && testData.status_code >= 400 ? <Fragment>
                                    <Alert severity="error">
                                        <AlertTitle>Error</AlertTitle>
                                        An error occurred with — <strong>{label} - {actionlabel}</strong><br /><br />
                                        Error:
                                        <DataInspector data={testData} finalStep={true}  />
                                    </Alert>
                                </Fragment> :
                                    <Fragment>
                                        <Alert severity="success" variant="outlined" style={{borderWidth: '0px 0px 0px 6px', borderStyle: 'none none none solid', marginBottom: '16px'}}>
                                            <AlertTitle>Success</AlertTitle>
                                            A request to <strong>{actionlabel}</strong> was done in <strong>{label}</strong> about {timeSince(actionTestTime)} ago<br/> {testData.Message ? "*"+testData.Message+"*" : "" }
                                        </Alert>
                                        {/* <IconButton color="primary" style={{ color: 'black', float: 'right', borderRadius: 50, marginTop: '-10px', marginRight: '15px' }} aria-label="close modal" onClick={handlePopClick}>
                                            <SettingsEthernetRoundedIcon style={{ color: 'black' }} />
                                        </IconButton>
                                        <Popper placement="left" id={id} open={openpop} anchorEl={anchorElPop} style={{ zIndex: 99 }}>
                                            <div className={classes.popper}>
                                                <React.Fragment>
                                                    <Typography color="inherit"><h4>Inject Sample Data</h4></Typography>
                                                    
                                                    {"ADVANCED: Customize the output response (must be JSON formatted)."}<br /><br />
                                                    <TextareaAutosize defaultValue={poptext} value={poptext} onChange={(e) => setPopText(e.target.value)} style={{ width: '350px', maxWidth: '350px', height: '200px', borderColor: 'lightgray', maxHeight: '250px' }} aria-label="minimum height" minRows={40} placeholder='{"data":{&#10;"key1":"value1",&#10;"key2":"value2"&#10; }&#10;}' />
                                                    <br /><br />
                                                    <Button onClick={handlePopClose} style={{ marginRight: '5px' }}>Close</Button><Button onClick={() => { setTestData(JSON.parse(poptext)); handlePopClose() }} variant="contained" color="primary">Submit</Button>
                                                </React.Fragment>
                                            </div>
                                        </Popper> */}
                                        <div id='inspector-json' style={{ maxHeight: '350px', overflowX: 'hidden', overflowY: 'scroll' }}>
                                            <DataInspector data={testData}  />
                                        </div>
                                    </Fragment>

                            }

                            <br /><br />
                            <div id='actions-save' style={{ width: '90%', height: '1px' }}></div>
                            <Button onClick={resetForm} className={classes.button} style={{ textTransform: 'none', fontSize: '18px' }} variant="outlined">
                                Retest action
                            </Button>
                            <Button disabled={nosave} variant='contained' color='primary' onClick={() => { saveNode(); handleSaveClick(); onPaneClick() }} className={classes.button} style={{marginLeft: '20px', textTransform: 'none', fontSize: '18px' }}>
                                Continue
                            </Button>
                        </Paper>
                    )}


                    <div ref={bottomRef} />
                </div> : null
        )
    } catch (e) {
        var airtableConfig = {
            method: 'post',
            url: 'https://api.airtable.com/v0/appb76LyMibAJXsfE/FrontendErrors',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${config.AIRTABLE_API_KEY}`
            },
            data: {
                'records': [
                    {
                        'fields': {
                            'Error source': 'Action Panel',
                            'Error': e.toString()
                        }
                    }
                ]
            }
        }

        axios(airtableConfig)

        onPaneClick();
    }
}

const Widget = (props) => {
    return <span>
        <img
            className="tag-img"
            src={props.icon}>
        </img>
        <b>{props.step} - {props.label}: </b><div style={{ display: 'inline', color: 'grey' }}>{props.cvalue}</div>
    </span>;
}

// Wrap ActionPanel with error boundary
const ActionPanelWithErrorBoundary = (props) => {
  return (
    <WorkflowErrorBoundary 
      componentName="ActionPanel"
      workflowId={props.workflowID}
      nodeId={props.selectedNode?.id}
    >
      <ActionPanel {...props} />
    </WorkflowErrorBoundary>
  );
};

export default ActionPanelWithErrorBoundary;


